module.exports = __webpack_public_path__ + "static/media/sfl_3.20282497.jpg";